import { executeRequest, JFSRequest } from '@jfs/network'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'
import { MerchantData } from './insertMerchant'

const responseParser = (data: any) => {
  if (data?.data?.response) {
    return data?.data
  } else {
    throw data
  }
}

const grantPermissions = (userData: MerchantData, tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.grantPermissions),
    method: 'POST',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: {
      mobile: { countryCode: '91', number: userData?.mobile },
      name: { firstName: userData?.firstName, lastName: userData?.lastName },
      department: 'Operations',
      entityId: userData?.mid,
      userType: '10',
      permissions: [
        { permissionId: '1', permissionValue: 'Y' },
        { permissionId: '2', permissionValue: 'Y' },
        { permissionId: '4', permissionValue: 'Y' },
        { permissionId: '5', permissionValue: 'Y' },
        { permissionId: '6', permissionValue: 'Y' },
        { permissionId: '12', permissionValue: 'Y' },
        { permissionId: '32', permissionValue: 'Y' },
        { permissionId: '40', permissionValue: 'Y' },
        { permissionId: '21', permissionValue: 'Y' },
        { permissionId: '33', permissionValue: 'Y' },
        { permissionId: '41', permissionValue: 'Y' },
        { permissionId: '35', permissionValue: 'Y' },
        { permissionId: '36', permissionValue: 'Y' },
        { permissionId: '10', permissionValue: 'Y' },
        { permissionId: '31', permissionValue: 'Y' },
        { permissionId: '11', permissionValue: 'Y' },
        { permissionId: '13', permissionValue: 'Y' },
        { permissionId: '14', permissionValue: 'Y' },
        { permissionId: '15', permissionValue: 'Y' },
        { permissionId: '17', permissionValue: 'Y' },
        { permissionId: '18', permissionValue: 'Y' },
        { permissionId: '19', permissionValue: 'Y' },
        { permissionId: '20', permissionValue: 'Y' },
      ],
    },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { grantPermissions }
